export const INBOUND_CALL_RING_SRC = "https://sdk.twilio.com/js/client/sounds/releases/1.0.0/incoming.mp3";
